import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { login, clearError } from '../../store/slices/authSlice';
import { toast } from 'react-toastify';

export default function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error, user } = useSelector((s) => s.auth);
  const [form, setForm] = useState({ email: '', password: '' });

  useEffect(() => { if (user) navigate(user.role === 'admin' ? '/admin' : '/'); }, [user, navigate]);
  useEffect(() => { if (error) { toast.error(error); dispatch(clearError()); } }, [error, dispatch]);

  const handleSubmit = (e) => { e.preventDefault(); dispatch(login(form)); };

  return (
    <div style={S.page}>
      <div style={S.card}>
        <div style={S.topBar} />
        <div style={S.inner}>
          <img src="/logo.svg" alt="Bhadralok" style={{ height: '48px', width: 'auto', display: 'block', margin: '0 auto 8px' }} />
          <p style={S.tagline}>Cha · Adda · Identity</p>

          <h2 style={S.title}>WELCOME BACK</h2>
          <p style={S.sub}>Sign in to your account</p>

          <form onSubmit={handleSubmit}>
            <label style={S.label}>Email Address</label>
            <input style={S.input} type="email" placeholder="your@email.com" value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })} required />

            <label style={S.label}>Password</label>
            <input style={S.input} type="password" placeholder="••••••••" value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })} required />

            <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '18px' }}>
              <Link to="/forgot-password" style={{ fontSize: '12px', color: 'var(--red)', fontWeight: 600 }}>Forgot Password?</Link>
            </div>

            <button className="btn-primary" type="submit" disabled={loading} style={{ width: '100%', justifyContent: 'center' }}>
              {loading ? 'SIGNING IN...' : 'SIGN IN →'}
            </button>
          </form>

          <div style={S.divider}><span>OR</span></div>

          <p style={S.switch}>New here? <Link to="/register" style={{ color: 'var(--red)', fontWeight: 700, textDecoration: 'underline' }}>Create an account</Link></p>

          <div style={S.benefits}>
            <p style={S.benefitsTitle}>WHY JOIN BHADRALOK?</p>
            {['Exclusive member discounts', 'Early access to new drops', 'Free shipping on all orders'].map((b) => (
              <p key={b} style={S.benefit}><span style={{ color: 'var(--green)' }}>✓</span> {b}</p>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

const S = {
  page:         { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--black)', padding: '20px' },
  card:         { background: '#fff', width: '100%', maxWidth: '420px' },
  topBar:       { height: '4px', background: 'linear-gradient(90deg,var(--red),var(--gold),var(--green))' },
  inner:        { padding: '32px' },
  logo:         { fontFamily: 'var(--font-display)', fontSize: '28px', letterSpacing: '4px', textAlign: 'center', marginBottom: '4px' },
  tagline:      { fontFamily: 'var(--font-script)', fontSize: '16px', color: 'var(--gold)', textAlign: 'center', marginBottom: '24px' },
  title:        { fontFamily: 'var(--font-display)', fontSize: '22px', letterSpacing: '2px', marginBottom: '4px' },
  sub:          { fontSize: '13px', color: '#888', marginBottom: '20px' },
  label:        { display: 'block', fontSize: '10px', fontWeight: 700, letterSpacing: '1px', textTransform: 'uppercase', color: '#777', marginBottom: '5px' },
  input:        { width: '100%', border: '1.5px solid var(--border)', background: 'var(--offwhite)', padding: '10px 13px', fontFamily: 'var(--font-body)', fontSize: '14px', outline: 'none', marginBottom: '14px', boxSizing: 'border-box', transition: 'border-color .2s' },
  divider:      { display: 'flex', alignItems: 'center', gap: '10px', margin: '18px 0', fontSize: '10px', color: '#aaa', fontWeight: 600, letterSpacing: '1px' },
  switch:       { textAlign: 'center', fontSize: '13px', color: '#888', marginBottom: '16px' },
  benefits:     { background: 'var(--light)', padding: '12px 14px', borderLeft: '3px solid var(--gold)', marginTop: '16px' },
  benefitsTitle:{ fontSize: '9px', fontWeight: 700, letterSpacing: '1.5px', textTransform: 'uppercase', color: 'var(--charcoal)', marginBottom: '8px' },
  benefit:      { fontSize: '12px', color: '#555', marginBottom: '4px' },
};
